<template>
  <ais-instant-search
    :search-client="searchClient"
    index-name="users"
    class="flex-grow-1">
    <div class="row no-gutters mt-3" ref="top">
      <div class="col-12">
        <div class="mb-3">
          <ais-search-box
            placeholder="Cerca utente"
            :value="value"
            @input="updateSearch"
            :class-names="{
            'ais-SearchBox-form': 'd-flex',
            'ais-SearchBox-input': 'form-control',
            'ais-SearchBox-submit': 'd-none',
            'ais-SearchBox-reset': 'd-none',
          }"
          />
        </div>
        <ais-hits>
          <template v-slot="{ items, sendEvent }">
            <div class="row mb-4">
              <div v-for="item in items" :key="item.id" class="col-sm-3 col-6 mb-4">
                <user-card :user="item" />
              </div>
            </div>
          </template>
        </ais-hits>
        <styled-search-navigation @click="pageClicked"/>
        <ais-stats />
      </div>
    </div>
  </ais-instant-search>
</template>

<script>
import StyledSearchNavigation from "./StyledSearchNavigation.vue";
import UserCard from "../Cards/UserCard.vue";

export default {
  name: "UsersSearch",
  components: {UserCard, StyledSearchNavigation},
  props: {
    searchClient: Object,
    value: String,
    subscribed: Boolean,
  },
  methods: {
    updateSearch(value) {
      this.$emit('input', value ? value : "");
    },
    pageClicked() {
      document.getElementsByTagName('body')[0].scrollIntoView({ behavior: "smooth" })
    }
  }
}
</script>

<style scoped>

</style>
